import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import TimePeriodInput from "../../../../components/reports/time-period-input/time-period-input.jsx";
import {useQuery} from "@tanstack/react-query";
import locationService from "../../../../services/web/location-service.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const occurrenceStatus = [
  {value: "ACTIVE", label: "Ativa"},
  {value: "CONCLUDED", label: "Concluída"}
]

const Filters = ({ setFilters, filters }) => {
  const {occurrencesDetails, occurrenceCityFact} = useReportFiltersFetch({fetchOccurrencesDetails: true, fetchOccurrenceCityFact: true});

  const {data: neighborhood = []} = useQuery({
    queryFn: locationService.getOccurrencesDetailsNeighborhood,
    queryKey: ["occurrences-details-neighborhood"]
  })


  return (
    <>
      <div className={`mb-2 ${minMenuHeight}`}>
        <form className={'space-y-4'}>
            <InputDateTime
              id="dtStart"
              label="Data inicial *"
              selected={filters.dtStart}
              onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
              classNameWrapper="w-full"
              dateFormat="L"
            />
            <InputDateTime
              id="dtEnd"
              label="Data final *"
              selected={filters.dtEnd}
              onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
              classNameWrapper="w-full"
              dateFormat="L"
            />

          <TimePeriodInput filters={filters} setFilters={setFilters} singleRow={true}/>

          <SelectComponent
            label="Natureza"
            isMulti={true}
            wrapValues={true}
            options={occurrencesDetails}
            value={filters.reason}
            onChange={(value) => setFilters(prev => ({...prev, reason: value}))}
            instanceId="reason"
            classNameWrapper="w-full"
          />

          <SelectComponent
            label="Status da ocorrência"
            isMulti={true}
            wrapValues={true}
            options={occurrenceStatus}
            value={filters.status}
            onChange={(value) => setFilters(prev => ({...prev, status: value}))}
            instanceId="status"
            classNameWrapper="w-full"
          />

          <SelectComponent
            id="city-fact"
            instanceId="city-fact"
            label="Município do fato"
            classNameWrapper="w-full"
            wrapValues={true}
            options={occurrenceCityFact}
            value={filters.cityFact}
            onChange={(value) => setFilters(prev => ({ ...prev, cityFact: value }))}
          />

          <SelectComponent
            id="neighborhood"
            instanceId="neighborhood"
            label="Bairro"
            isMulti={true}
            classNameWrapper="w-full"
            wrapValues={true}
            options={neighborhood}
            value={filters.neighborhood}
            onChange={(value) => setFilters(prev => ({ ...prev, neighborhood: value }))}
          />

          <div className={"ml-1"}>
            <InputCheckbox
              id="onlyMyCity"
              label="Apenas ocorrências da minha corporação"
              checked={filters.onlyMyCity}
              onChange={(e) => setFilters(prev => ({...prev, onlyMyCity: e.target.checked}))}
            />
          </div>

          <div className={"mb-2 ml-1"}>
            <InputCheckbox
              id="archivedOccurrences"
              label="Contabilizar ocorrências arquivadas"
              checked={filters.archivedOccurrences}
              onChange={(e) => setFilters(prev => ({...prev, archivedOccurrences: e.target.checked}))}
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default Filters;